import { mutatorAction } from 'satcheljs';
import { getCopilotChatDrawerState } from '../store/store';

export const setShowBizChatInReadingPaneMutator: (
    targetWindow: Window,
    showInReadingPane: boolean
) => void = mutatorAction(
    'setShowBizChatInReadingPaneMutator',
    (targetWindow: Window, showInReadingPane: boolean): void => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (!state) {
            return;
        }
        state.showInReadingPane = showInReadingPane;
    }
);
